var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFaq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M16.666 147.335h166.667s-32.953-7.446-51.542-13.994c-6.865-2.429-13.149-5.334-19.381-7.024-14.206-3.908-35.54-.37-55.344 5.651-7.816 2.323-40.4 15.367-40.4 15.367z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M19.515 148.077l161.333.317s-19.91-15.315-32.954-16.741c-10.245-1.109-26.087 3.327-33.481 5.756-7.393 2.43-16.37 6.443-27.672 7.024-18.325.951-22.074-11.143-33.798-9.294-12.727 1.954-33.428 12.938-33.428 12.938z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear)",
    d: "M34.196 139.993c0-2.06 1.69-3.697 3.697-3.697 2.006 0 3.696 1.69 3.696 3.697 0 1.901-1.478 3.485-3.327 3.696v3.908c0 .211-.211.37-.37.317-.158 0-.316-.158-.316-.317v-3.908c-1.954-.211-3.38-1.795-3.38-3.696z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear)",
    d: "M56.852 120.296c0-.476.423-.898.898-.898-.211-1.056.475-2.113 1.584-2.324.898-.158 1.796.264 2.218 1.162.792-.475 1.796-.211 2.27.581.476.792.212 1.795-.58 2.271-.264.158-.528.211-.845.211H57.75c-.528-.053-.898-.475-.898-1.003z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear)",
    d: "M49.042 143.32c0-1.215.95-2.166 2.165-2.166s2.165.951 2.165 2.166c0 1.109-.845 2.059-1.954 2.112v2.271c0 .105-.105.211-.21.211-.106 0-.212-.106-.212-.211v-2.271c-1.162-.106-2.007-1.056-1.954-2.112z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear)",
    d: "M133.585 126.156c0-.634.476-1.162 1.162-1.162-.264-1.373.581-2.641 1.954-2.905 1.162-.211 2.271.37 2.746 1.426 1.004-.581 2.218-.264 2.799.74.581 1.003.264 2.218-.739 2.798-.317.212-.687.264-1.056.264h-5.757c-.633-.052-1.109-.528-1.109-1.161z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear)",
    d: "M165.698 141.259c0-1.849 1.479-3.327 3.327-3.327 1.849 0 3.327 1.478 3.327 3.327 0 1.69-1.267 3.115-3.01 3.274v3.485c0 .159-.158.317-.317.317-.158 0-.317-.158-.317-.317v-3.485c-1.69-.106-3.01-1.532-3.01-3.274z",
    opacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear)",
    d: "M51.523 89.462c0-1.162-.898-2.06-2.06-2.06.475-2.429-1.109-4.752-3.538-5.175-2.06-.37-4.066.687-4.911 2.535-1.743-1.004-4.014-.422-5.017 1.32-1.004 1.743-.423 4.014 1.32 5.017.581.317 1.215.475 1.848.475l10.351-.052c1.162-.053 2.007-1.004 2.007-2.06z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear)",
    d: "M65.782 73.036l.687-1.69h-.792l-1.32 1.69h-2.694l.634-.528h-.634l-1.373.528h-4.172c-.422 0-.74.317-.74.74 0 .422.318.739.74.739h9.506c.422 0 .74-.317.74-.74-.053-.369-.265-.633-.582-.739z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear)",
    d: "M67.681 74.25c.292 0 .529-.237.529-.528 0-.292-.237-.529-.529-.529-.291 0-.528.237-.528.529 0 .291.237.528.528.528z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear)",
    d: "M69.106 74.144c.175 0 .317-.141.317-.316 0-.175-.142-.317-.317-.317-.175 0-.317.142-.317.317 0 .175.142.316.317.316z",
    opacity: 0.6
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear)",
    d: "M156.613 61.207c5.395 0 9.769-4.374 9.769-9.77s-4.374-9.77-9.769-9.77c-5.396 0-9.77 4.374-9.77 9.77s4.374 9.77 9.77 9.77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear)",
    d: "M174.88 59.778c0-1.478-1.214-2.693-2.693-2.693.634-3.169-1.478-6.232-4.594-6.813-2.641-.527-5.334.898-6.443 3.38-2.271-1.373-5.228-.58-6.601 1.743-1.373 2.27-.581 5.228 1.743 6.601.739.423 1.584.687 2.482.634l13.572-.053c1.425-.158 2.534-1.373 2.534-2.799z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear)",
    d: "M160.15 63.005c0-1.162-.898-2.06-2.06-2.06.475-2.429-1.109-4.752-3.538-5.175-2.06-.37-4.066.687-4.911 2.535-1.743-1.003-4.014-.422-5.017 1.32-1.004 1.743-.423 4.014 1.32 5.017.581.317 1.215.476 1.901.476l10.351-.053c1.109-.053 1.954-.95 1.954-2.06z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear)",
    d: "M71.48 154.68h55.925c1.215 0 2.218 1.003 2.218 2.218v.053c0 1.214-1.003 2.218-2.218 2.218H71.48c-1.214 0-2.218-1.004-2.218-2.218v-.053c0-1.215 1.004-2.218 2.218-2.218z",
    opacity: 0.28
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear)",
    d: "M123.978 86.712c.951 5.914 3.75 11.407 8.027 15.631l5.228-2.693c.634-.317 1.373-.264 1.954.159 1.849 1.373 3.908 2.376 6.073 3.063 1.004.316 1.532 1.373 1.215 2.376l-2.06 6.284c-.317 1.004-1.373 1.532-2.376 1.215-16.899-5.387-26.141-23.5-20.754-40.347.317-1.003 1.373-1.531 2.376-1.214l6.337 2.007c1.004.317 1.532 1.373 1.215 2.376-.687 2.165-1.056 4.436-1.056 6.76 0 .686-.423 1.373-1.004 1.69l-5.175 2.693z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100.526 123.414l11.037-24.134c.475-1.056 1.743-1.532 2.852-1.056l42.458 19.381c1.057.475 1.532 1.742 1.057 2.851l-11.038 24.134c-.475 1.057-1.742 1.532-2.851 1.057l-42.459-19.382c-1.056-.528-1.532-1.795-1.056-2.851z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_linear)",
    d: "M100.526 123.414l11.037-24.134c.475-1.056 1.743-1.532 2.852-1.056l42.458 19.381c1.057.475 1.532 1.742 1.057 2.851l-11.038 24.134c-.475 1.057-1.742 1.532-2.851 1.057l-42.459-19.382c-1.056-.528-1.532-1.795-1.056-2.851z",
    opacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M148.797 133.398c-.475 1.057-1.742 1.532-2.799 1.057l-5.492-2.482c-1.056-.476-1.531-1.743-1.056-2.852l3.644-7.974c.475-1.057 1.743-1.532 2.852-1.057l5.492 2.483c1.056.475 1.531 1.742 1.056 2.851l-3.697 7.974z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M146.26 129.279c-.211-.264.053-.528.264-.581.264-.106.74-.634.74-.634.264 0 .581-.158.686-.37.37-.422.053-.686.053-.686s.687-.687.739-1.479c.053-1.003-1.161-1.954-1.795-1.267-1.479-1.109-2.165 1.267-2.165 1.267s-.423-.105-.476.475c-.105.265-.052.581.159.793 0 0-.053.686.053 1.003.052.211.105.581-.264.581-.74.053-2.535-.687-3.222.686l6.76 3.063c.634-1.373-1.109-2.27-1.532-2.851z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M143.254 115.709c-.211.529-.845.74-1.373.476l-14.628-6.654c-.528-.211-.74-.845-.528-1.373.211-.528.844-.74 1.373-.476l14.628 6.654c.528.212.792.845.528 1.373zM136.491 117.873c-.212.475-.793.686-1.268.475l-22.972-10.509c-.475-.211-.687-.792-.475-1.267.211-.476.792-.687 1.267-.476l22.972 10.509c.476.212.687.793.476 1.268zM128.515 119.034c-.212.423-.687.634-1.162.423l-16.952-7.763c-.423-.212-.634-.687-.423-1.162.212-.423.687-.634 1.162-.423l16.952 7.763c.423.212.634.74.423 1.162zM126.561 123.364c-.211.422-.686.633-1.109.422l-17.004-7.763c-.423-.211-.634-.686-.423-1.162.211-.422.687-.633 1.109-.422l17.005 7.763c.422.264.581.739.422 1.162z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.339,
    d: "M136.125 137.198c2.007.687 5.387.581 6.548-1.426-.845-.845-3.749-.422-3.696 1.109.053 1.69 2.799 1.321 3.908 1.004-.74 0-1.373.317-1.004.95.264.476 1.32.212 1.743.528.686.529.106 1.479 1.267 1.849"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint17_linear)",
    d: "M66.725 80.746c-9.664 3.538-14.575 14.259-11.037 23.923 3.538 9.664 14.259 14.575 23.923 11.037 9.664-3.538 14.575-14.259 11.037-23.923-3.59-9.664-14.311-14.575-23.923-11.037zm-7.974 24.292l6.39-2.376c.634 1.532 1.373 3.063 2.165 4.489l-5.703 2.112c-1.11-1.267-2.113-2.693-2.852-4.225zM71.32 89.301l-2.218-6.02c1.69.37 3.75 2.007 5.756 4.753L71.32 89.3zm5.07 1.004c.844 1.425 1.584 2.904 2.218 4.436l-4.595 1.69-1.69-4.648 4.067-1.478zm-9.876-6.126l2.218 6.02-3.538 1.32c-.211-3.327.317-5.967 1.32-7.34zm3.169 8.608l1.69 4.647-4.595 1.69c-.528-1.584-.95-3.222-1.214-4.859l4.119-1.478zm-5.44 7.287l-6.39 2.377c-.475-1.637-.633-3.38-.528-5.07l5.704-2.112c.264 1.637.686 3.221 1.214 4.805zm3.486 1.637l4.594-1.689 1.69 4.647-4.119 1.531c-.792-1.478-1.532-2.957-2.165-4.489zm7.287 5.493l2.218 6.02c-1.69-.37-3.749-2.007-5.756-4.753l3.538-1.267zm4.806 5.069l-2.218-6.02 3.538-1.32c.212 3.38-.264 6.02-1.32 7.34zm-3.168-8.608l-1.69-4.647 4.594-1.69c.528 1.585.95 3.222 1.215 4.859l-4.12 1.478zm5.439-7.287L88.483 94c.475 1.637.634 3.38.528 5.07l-5.703 2.112c-.264-1.584-.687-3.221-1.215-4.805zm-.95-2.535c-.634-1.532-1.374-3.063-2.166-4.489l5.704-2.112c1.214 1.214 2.165 2.64 2.904 4.224l-6.443 2.377zm1.161-8.608L77.5 87.03c-.74-1.056-1.585-2.112-2.483-3.063-.58-.58-1.161-1.161-1.848-1.637 3.274 0 6.496 1.004 9.136 2.905zm-19.486.898c-.159.792-.264 1.584-.317 2.429-.053 1.32-.053 2.64.105 3.96l-4.805 1.796c.792-3.168 2.535-6.02 5.017-8.185zm1.214 25.137l4.806-1.796c.74 1.057 1.584 2.113 2.482 3.063.58.581 1.162 1.162 1.848 1.638-3.274-.053-6.443-1.057-9.136-2.905zm19.487-.951c.158-.792.264-1.584.317-2.429.052-1.32.052-2.64-.106-3.961l4.806-1.795c-.792 3.221-2.535 6.02-5.017 8.185z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint18_linear)",
    d: "M75.021 113.013l12.938 20.648c.212.37.106.793-.21 1.004l-30.42 19.064c-.369.211-.791.106-1.002-.211l-12.939-20.649c-.211-.369-.105-.792.212-1.003l30.418-19.064c.37-.264.792-.159 1.003.211z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint19_linear)",
    d: "M75.021 113.013l12.938 20.648c.212.37.106.793-.21 1.004l-30.42 19.064c-.369.211-.791.106-1.002-.211l-12.939-20.649c-.211-.369-.105-.792.212-1.003l30.418-19.064c.37-.264.792-.159 1.003.211z",
    opacity: 0.04
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint20_linear)",
    d: "M86.854 135.246l-28.57 17.903c-.317.211-.792.105-1.004-.212-.105-.158-.158-.369-.053-.581l5.862-21.757c.159-.581.74-1.003 1.373-.845l22.128 4.172c.37.053.633.422.58.792-.052.211-.158.37-.316.528z",
    opacity: 0.04
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint21_linear)",
    d: "M87.75 134.661l-30.418 19.064 6.073-22.655c.158-.581.687-.95 1.32-.792l23.025 4.383z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint22_linear)",
    d: "M43.603 131.809l22.76 4.858c1.163.211 2.325-.475 2.641-1.637l5.017-22.285-30.418 19.064z",
    opacity: 0.04
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint23_linear)",
    d: "M43.603 131.809l22.127 4.119c1.11.211 2.218-.475 2.482-1.584l5.81-21.599-30.419 19.064z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint24_linear)",
    d: "M122.814 57.295v94.107c0 3.063-2.482 5.545-5.545 5.545H81.252c-3.062 0-5.544-2.482-5.544-5.493V57.295c0-3.063 2.482-5.545 5.544-5.545h36.069c3.063.053 5.493 2.482 5.493 5.545z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81.251 151.666c-2.27 0-4.12-1.849-4.12-4.12V60.728c0-2.271 1.85-4.12 4.12-4.12h36.069c2.271 0 4.119 1.849 4.119 4.12v86.818c0 2.271-1.848 4.12-4.119 4.12H81.251z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint25_linear)",
    d: "M116.11 120.355c0 .845-.687 1.532-1.532 1.532H83.79c-.845 0-1.531-.687-1.531-1.532s.686-1.531 1.531-1.531h30.788c.845 0 1.532.686 1.532 1.531z",
    opacity: 0.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M109.086 126.109c0 .634-.475 1.109-1.109 1.109h-24.61c-.633 0-1.108-.475-1.108-1.109 0-.633.475-1.109 1.109-1.109h24.609c.581 0 1.109.476 1.109 1.109zM109.086 130.227c0 .634-.475 1.109-1.109 1.109h-24.61c-.633 0-1.108-.475-1.108-1.109 0-.633.475-1.109 1.109-1.109h24.609c.581 0 1.109.476 1.109 1.109z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint26_linear)",
    d: "M104.116 107.679c-1.426-.739-.687-2.165 0-2.852.845-.845 1.848-3.802 1.848-3.802 1.162-.475 1.954-1.584 2.06-2.852.686-2.43-1.162-2.852-1.162-2.852s1.479-4.066.264-7.182c-1.637-4.066-8.186-5.545-9.295-1.742-7.763-1.637-6.126 9.03-6.126 9.03s-1.9.37-1.108 2.852c.105 1.267.897 2.323 2.112 2.851 0 0 1.056 2.905 1.901 3.75.687.634 1.426 2.112 0 2.852-2.852 1.531-11.354 1.954-11.301 8.608l32.161-.159c0-6.654-8.503-7.023-11.354-8.502z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint27_linear)",
    d: "M122.392 139.261V140.265c0 .211-.053.475-.053.792v.317c-.053.422-.106.897-.211 1.373v.158c-.106.528-.211 1.109-.317 1.69 0 .053-.053.158-.053.264-.053.317-.158.634-.264.951 0 .052-.053.158-.053.264-.053.158-.053.264-.105.369 0 .053-.053.159-.053.264-.053.212-.159.423-.211.634 0 .053-.053.159-.053.211-.053.159-.106.264-.159.423-.052.105-.052.211-.105.264-.053.105-.053.211-.159.317-.053.105-.053.158-.105.264v.053c-.053.052-.053.158-.106.264v.052c-.053.106-.053.159-.106.264v.053c-.052.106-.105.212-.158.264-.264.581-.581 1.109-.898 1.637-.053.053-.053.106-.105.159-.212.317-.476.634-.687.898-.053.052-.053.052-.106.158l-.105.106-.053.052-.106.106-.211.211-.105.106-.106.106c-.053.052-.053.052-.158.105l-.106.106-.106.105-.105.106c-.053.053-.053.053-.159.106-.105.052-.211.158-.369.264-.264.211-.581.369-.898.528-.211.105-.37.211-.581.264-.053 0-.159.053-.211.053-.053 0-.159.052-.212.052-.052 0-.158.053-.211.053-.053 0-.158.053-.211.053-.053 0-.106 0-.158.053h-.476c-7.235-1.637-8.396-13.044-8.608-15.949 0-.422.212-.792.581-1.003l7.763-4.33c.159-.106.37-.159.528-.159.159 0 .37.053.528.159l7.763 4.33c0 .264.212.634.159 1.056z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M122.395 139.261V140.265c0 .211-.053.475-.053.792v.317c-.053.422-.106.898-.211 1.373v.158c-.106.528-.211 1.109-.317 1.69 0 .053-.053.159-.053.264-.053.317-.158.634-.264.951 0 .053-.053.158-.053.264-.052.158-.052.264-.105.369 0 .053-.053.159-.053.265-.053.211-.159.422-.211.633 0 .053-.053.159-.053.211-.053.159-.106.265-.159.423-.052.106-.052.211-.105.264-.053.106-.053.211-.159.317-.052.105-.052.158-.105.264v.053c-.053.053-.053.158-.106.264v.053c-.053.105-.053.158-.105.264v.052c-.053.106-.106.212-.159.264-.264.581-.581 1.109-.898 1.638-.052.052-.052.105-.105.158-.212.317-.476.634-.687.898-.053.053-.053.053-.105.158l-.106.106-.053.053-.105.105-.212.211-.105.106-.106.106c-.053.053-.053.053-.158.105l-.106.106-.106.106-.105.105c-.053.053-.053.053-.159.106-.105.053-.211.158-.369.264-.264.211-.581.37-.898.528-.211.106-.37.211-.581.264-.053 0-.158.053-.211.053-.053 0-.159.053-.211.053-.053 0-.159.052-.212.052-.053 0-.158.053-.211.053-.053 0-.106 0-.158.053h-.106c-.053 0-.106 0-.158.053v-21.388c.158 0 .369.053.528.158l7.763 4.331c.052.105.264.528.211.95z",
    opacity: 0.29
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M121.6 144.806c-.739 3.274-2.165 6.97-4.858 9.03-1.268-.211-2.324-.845-3.116-1.796-.845-.95-1.32-2.165-1.32-3.538 0-1.373.475-2.587 1.32-3.538 1.003-1.162 2.429-1.848 4.066-1.848 1.532 0 2.905.633 3.908 1.69z",
    opacity: 0.29
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M118.327 153.466c2.975 0 5.387-2.412 5.387-5.387 0-2.975-2.412-5.387-5.387-5.387-2.975 0-5.387 2.412-5.387 5.387 0 2.975 2.412 5.387 5.387 5.387z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ACF0",
    d: "M114.679 147.969c.264-.264.687-.264 1.004 0l1.425 1.426c.053.053.212.053.264 0l3.697-3.697c.264-.264.687-.264 1.004 0 .264.264.264.687 0 1.003l-4.172 4.172c-.37.37-.951.37-1.321 0l-1.848-1.848c-.317-.317-.317-.792-.053-1.056z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 99.993,
    x2: 99.993,
    y1: 147.348,
    y2: 124.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 100.192,
    x2: 100.192,
    y1: 148.389,
    y2: 131.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 37.893,
    x2: 37.893,
    y1: 147.91,
    y2: 136.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#777",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 60.435,
    x2: 60.435,
    y1: 121.252,
    y2: 117.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#777",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 51.174,
    x2: 51.174,
    y1: 147.904,
    y2: 141.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#777",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 138.018,
    x2: 138.018,
    y1: 127.323,
    y2: 122.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#777",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 169.033,
    x2: 169.033,
    y1: 148.384,
    y2: 137.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#777",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 43.498,
    x2: 43.545,
    y1: 82.096,
    y2: 91.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 60.905,
    x2: 60.905,
    y1: 74.503,
    y2: 71.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3154",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2B3254",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2A3554",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#2A3853",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#293A53",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#293B53",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293B53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 67.689,
    x2: 67.689,
    y1: 74.238,
    y2: 73.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3154",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2B3254",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2A3554",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#2A3853",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#293A53",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#293B53",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293B53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 69.094,
    x2: 69.094,
    y1: 74.134,
    y2: 73.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3154",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2B3254",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2A3554",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#2A3853",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#293A53",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#293B53",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293B53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 156.614,
    x2: 156.614,
    y1: 61.219,
    y2: 41.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC41C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DDE93C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 164.341,
    x2: 164.401,
    y1: 50.126,
    y2: 62.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 152.132,
    x2: 152.178,
    y1: 55.645,
    y2: 65.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 99.451,
    x2: 99.451,
    y1: 159.211,
    y2: 154.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3154",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2A3654",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2A3754",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#293A53",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293B53",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 116.789,
    x2: 149.162,
    y1: 86.803,
    y2: 97.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B9428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 135.613,
    x2: 122.818,
    y1: 107.894,
    y2: 135.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2BA4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#289CD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#228FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E85AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 55.691,
    x2: 90.631,
    y1: 104.692,
    y2: 91.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4775B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#4479BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#3D84C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3989C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 58.822,
    x2: 72.551,
    y1: 122.284,
    y2: 144.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E4A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 65.686,
    x2: 65.686,
    y1: 153.816,
    y2: 112.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24252E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 63.575,
    x2: 72.525,
    y1: 129.778,
    y2: 144.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24252E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 63.897,
    x2: 72.553,
    y1: 130.371,
    y2: 144.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E4A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 58.826,
    x2: 67.758,
    y1: 122.28,
    y2: 136.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24252E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 58.823,
    x2: 67.208,
    y1: 122.285,
    y2: 135.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E4A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 99.271,
    x2: 99.271,
    y1: 51.782,
    y2: 156.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 99.197,
    x2: 99.197,
    y1: 121.902,
    y2: 118.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13637B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B80A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 83.337,
    x2: 115.507,
    y1: 100.257,
    y2: 100.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#13637B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 104.751,
    x2: 122.407,
    y1: 144.475,
    y2: 144.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94273A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6514D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFaq);
export default __webpack_public_path__ + "static/media/ic-faq.0d981562d62fdd4d12f11268b8eb1338.svg";
export { ForwardRef as ReactComponent };